import { Option } from "src/types/storefront";

export default function getValuesByName(
	options: Option[],
	optionName: string
): string[] {
	return options.find(({ name }) => name === optionName)?.values || [];
}
